import {
	ConditionOperand,
	FormulaComponentType,
	FunctionOperand,
	HTMLElementTag,
	LogicOperand,
	MathOperand,
	IfElseOperands,
} from "node-library/dist/constants";
import {
	FrontendCompanyResultCalculationFormula,
	FrontendCompanyResultCalculationFormulaComponents,
	FrontendCompanyWorkflowSteps,
} from "node-library/dist/structures/frontendTestWorkflowStructureDefinitions";

export function buildStepTree(steps: Array<FrontendCompanyWorkflowSteps>): {
	rootNodes: Array<FrontendCompanyWorkflowSteps>;
	childrenMap: Map<string, Array<FrontendCompanyWorkflowSteps>>;
} {
	const stepChildrenMap = new Map<
		string,
		Array<FrontendCompanyWorkflowSteps>
	>();

	const rootNodes: Array<FrontendCompanyWorkflowSteps> = [];
	// Group into tree
	steps.forEach((step) => {
		if (step.parentStepId) {
			const childNodes = stepChildrenMap.get(step.parentStepId);

			if (childNodes) {
				childNodes.push(step);
			} else {
				stepChildrenMap.set(step.parentStepId, [step]);
			}
		} else {
			rootNodes.push(step);
		}
	});

	rootNodes.sort((a, b) => a.displayIndex - b.displayIndex);
	for (const childSteps of Array.from(stepChildrenMap.values())) {
		childSteps.sort((a, b) => a.displayIndex - b.displayIndex);
	}

	return { rootNodes: rootNodes, childrenMap: stepChildrenMap };
}

// export function convertHTMLElementTagToJSX(
// 	tag: HTMLElementTag
// ): keyof JSX.IntrinsicElements {
// 	const tagMap: Record<HTMLElementTag, keyof JSX.IntrinsicElements> = {
// 		DIV: "div",
// 		SPAN: "span",
// 		TABLE: "table",
// 		ROW: "tr",
// 		CELL: "td",
// 	};
// 	return tagMap[tag];
// }
